import type { AxiosProgressEvent, AxiosRequestConfig } from 'axios';

export const DEFAULT_CONFIG: AxiosRequestConfig = {
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
};

export type UploadProgressEvent = Pick<AxiosProgressEvent, 'loaded' | 'total'>;
